export default "__VITE_ASSET__Di62Lqv7__"